'use strict';

import Vue from 'vue';
import options from './index.vue';
import itemOptions from './waterfallItem.vue';

Vue.component('tg-waterfall', options);
Vue.component('tg-waterfall-item', itemOptions);